import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is carried entirely by a secure httpOnly cookie set by the backend.
// `withCredentials` makes the browser attach that cookie on same-origin calls.
// No token is ever read from or written to localStorage (XSS-safe).
const api = axios.create({ baseURL: API, withCredentials: true });

api.interceptors.response.use(
  (r) => r,
  (err) => {
    // On an auth failure away from the login screen, let the app fall back to
    // its unauthenticated state; the httpOnly cookie is cleared server-side on
    // logout / expiry.
    return Promise.reject(err);
  }
);

export default api;
